// extracted by mini-css-extract-plugin
module.exports = {"component":"FaqCollection_component__F_8rg"};